(function () {
"use strict";
function qs(sel, root) { return (root || document).querySelector(sel); }
function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
function esc(s) { return String(s || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;"); }
function initScentFinder() {
    var page = qs("[data-scent-page]");
    var main = qs("[data-scent-main]");
    if (!page || !main) return;
    if (page.dataset.scentFinderBound === "1") return;
    page.dataset.scentFinderBound = "1";

    var cfgEl = document.getElementById("scent-finder-config");
    var config = {};
    try {
      if (cfgEl && cfgEl.textContent) config = JSON.parse(cfgEl.textContent.trim());
    } catch (e) {}

    var rootUrl =
      (page.dataset && page.dataset.scentRoot) ||
      (window.theme && window.theme.routes && window.theme.routes.rootUrl) ||
      "/";

    var ui = config.ui || {};
    var storageCfg = config.storage || {};
    var closeHref = ui.closeUrl || rootUrl;
    var SHEET_SENT_KEY = "illusion_scent_sheet_v2";

    var L = Object.assign(
      {
        resultsKicker: "Profilinize göre",
        resultsTitleHtml:
          'Sana en yakın<br/><span style="font-style:italic;color:rgba(255,255,255,0.45)">iki imza.</span>',
        resultsAsideLabel: "ALTERNATİF",
        repeatQuiz: "Testi Yeniden Yap",
        homeLink: "Ana Sayfa",
        quizContinue: "Devam",
        quizFinish: "Sonuçları Gör",
        reviewMain: "Ürünü İncele",
        reviewAlt: "Alternatifi İncele",
      },
      config.labels || {}
    );

    var DEFAULT_STEPS = [
      {
        id: "category", number: "01", question: "Hangi koku kategorisine bakıyorsun?",
        hint: "Önce kategoriyi seç", type: "single",
        options: [
          { value: "kadin", label: "Kadın parfümleri", sub: "Feminen imzalar" },
          { value: "erkek", label: "Erkek parfümleri", sub: "Maskülen imzalar" },
        ],
      },
      {
        id: "time", number: "02", question: "Bu kokuyu en çok ne zaman kullanmayı düşünüyorsun?",
        hint: "Kullanım anı", type: "single",
        options: [
          { value: "gunduz", label: "Gündüz", sub: "Aydınlık, hafif" },
          { value: "gunboyu", label: "Gün boyu", sub: "Sabahtan akşama" },
          { value: "aksam", label: "Akşam", sub: "Daha yoğun, iddialı" },
        ],
      },
      {
        id: "effect", number: "03", question: "Nasıl bir etki bırakmasını istersin?",
        hint: "Ana duygu", type: "single",
        options: [
          { value: "ferah", label: "Ferah ve temiz", sub: "Aydınlık, nefes alan" },
          { value: "sicak", label: "Sıcak ve sarıp saran", sub: "Yakın, tatlı" },
          { value: "rafine", label: "Rafine ve dengeli", sub: "Sade, zarif" },
          { value: "yogun", label: "Yoğun ve etkileyici", sub: "İddialı, iz bırakan" },
        ],
      },
      {
        id: "note", number: "04", question: "Hangi nota ailesine daha yakınsın?",
        hint: "Koku yönü", type: "single",
        options: [
          { value: "narenciye_su_temiz", label: "Narenciye / su / temiz", sub: "Parlak, ferah" },
          { value: "ciceksi_pudrali_yumusak", label: "Çiçeksi / pudralı / yumuşak", sub: "Narin, zarif" },
          { value: "vanilya_amber_tatli", label: "Vanilya / amber / tatlı", sub: "Sıcak, gurme" },
          { value: "odunsu_baharatli_derin", label: "Odunsu / baharatlı / derin", sub: "Güçlü, derin" },
        ],
      },
      {
        id: "intensity", number: "05", question: "Kokun tende nasıl dursun istersin?",
        hint: "Tende duruş", type: "single",
        options: [
          { value: "hafif", label: "Hafif ve yakın", sub: "Tene yakın" },
          { value: "dengeli", label: "Dengeli ama fark edilir", sub: "Ölçülü" },
          { value: "belirgin", label: "Daha belirgin ve iz bırakan", sub: "Güçlü sillage" },
        ],
      },
    ];

    var NOTE_MAP = {
      narenciye_su_temiz: ["narenciye", "su", "temiz", "aquatic", "citrus"],
      ciceksi_pudrali_yumusak: ["ciceksi", "pudrali", "yumusak", "miskli"],
      vanilya_amber_tatli: ["vanilya", "amber", "tatli", "gurme"],
      odunsu_baharatli_derin: ["odunsu", "baharatli", "derin"],
    };

    var IMGBASE = "https://cdn.shopify.com/s/files/1/0738/2863/0606/files/";
    var P = {
      AERIEN: "illusione-aerien-edp-kadin-parfum-50-ml",
      AMBRE: "illusione-ambre-edp-kadin-parfum-50-ml",
      AMELINE: "illusione-ameline-edp-kadin-parfum-50-ml",
      DORE: "illusione-dore-edp-kadin-parfum-50-ml",
      FORTUNE: "illusione-fortune-edp-kadin-parfum-50-ml",
      IDYLLE: "illusione-idylle-edp-kadin-parfum-50-ml",
      LUMIERE: "illusione-lumiere-edp-kadin-parfum-50-ml",
      MIRAGE: "illusione-mirage-edp-kadin-parfum-50-ml",
      ROSELIE: "illusione-roselie-edp-kadin-parfum-50-ml",
      SOLENA: "illusione-solena-edp-kadin-parfum-50-ml",
      ARWEN: "illusione-arwen-edp-erkek-parfum-100-ml",
      AUSTIN: "illusione-austin-edp-erkek-parfum-100-ml",
      ELAN: "illusione-elan-edp-erkek-parfum-100-ml",
      NUAGE: "illusione-nuage-edp-erkek-parfum-100-ml",
      OCEANE: "illusione-oceane-edp-erkek-parfum-100-ml",
    };

    var CATALOG = {};
    CATALOG[P.AERIEN]  = { name: "Aérien",  subtitle: "Çiçeksi · Pudralı · Misk",   price: 1199, image: IMGBASE + "1200x1600_aerien.jpg?v=1781864850",  time: ["gunduz","gunboyu"], notes: ["narenciye","temiz"],            intensity: ["hafif","dengeli"],   reason: "Ferah, narenciyeli ve temiz; gün boyu hafif kalmasını isteyenlere." };
    CATALOG[P.LUMIERE] = { name: "Lumière", subtitle: "Tatlı · Vanilya · Gurme",    price: 1199, image: IMGBASE + "illusion-u-ru-nlumiere.jpg?v=1779275903", time: ["gunduz"],           notes: ["ciceksi","temiz"],             intensity: ["hafif"],             reason: "Çiçeksi ve zarif; hafif ama şık bir gündüz kokusu arayanlara." };
    CATALOG[P.IDYLLE]  = { name: "Idylle",  subtitle: "Meyveli · Şekerli · Çiçeksi", price: 1199, image: IMGBASE + "illusion-u-ru-nidyl.jpg?v=1779275895",   time: ["gunduz","gunboyu"], notes: ["ciceksi","yumusak"],           intensity: ["hafif","dengeli"],   reason: "Rafine ve yumuşak çiçeksi; dengeli, sade bir imza isteyenlere." };
    CATALOG[P.AMELINE] = { name: "Améline", subtitle: "Pudramsı · Çiçeksi · Ferah",  price: 1199, image: IMGBASE + "1600x200_Ameline.jpg?v=1781278296",    time: ["gunduz","gunboyu"], notes: ["pudrali","ciceksi"],           intensity: ["hafif"],             reason: "Pudralı ve çiçeksi; hafif, narin bir dokunuş sevenlere." };
    CATALOG[P.ROSELIE] = { name: "Roselie", subtitle: "Kremsi · Misk · Pudramsı",    price: 1199, image: IMGBASE + "parfum_kapaklar_roselie.jpg?v=1781277725", time: ["gunduz","gunboyu"], notes: ["miskli","pudrali"],            intensity: ["hafif","dengeli"],   reason: "Miskli-pudralı, rafine bir denge; fark edilir ama abartısız." };
    CATALOG[P.DORE]    = { name: "Doré",    subtitle: "Tatlı · Gurme · Çiçeksi",     price: 1199, image: IMGBASE + "1600x2000_Dore.jpg?v=1781278296",      time: ["gunboyu","aksam"],  notes: ["gurme","vanilya","tatli"],     intensity: ["dengeli","belirgin"], reason: "Sıcak, sarıp saran ve daha yumuşak bir etki arayanlara." };
    CATALOG[P.SOLENA]  = { name: "Soléna",  subtitle: "Baharatlı · Tatlı · Vanilya", price: 1199, image: IMGBASE + "illusion-urunsolena.jpg?v=1779276162",  time: ["aksam"],            notes: ["vanilya","tatli","baharatli"], intensity: ["belirgin"],          reason: "Daha tatlı, daha dikkat çekici ve daha güçlü bir sıcaklık isteyenlere." };
    CATALOG[P.AMBRE]   = { name: "Ambre",   subtitle: "Amber · Paçuli · Gül",        price: 1199, image: IMGBASE + "1600x200_Ambre.jpg?v=1781278296",      time: ["aksam"],            notes: ["amber","tatli"],               intensity: ["belirgin"],          reason: "Amber-tatlı; akşam için sarıp saran, belirgin bir sıcaklık." };
    CATALOG[P.MIRAGE]  = { name: "Mirage",  subtitle: "Çiçeksi · Odunsu · Kremsi",   price: 1199, image: IMGBASE + "parfum_kapaklar_final_m.jpg?v=1781015881", time: ["aksam"],            notes: ["derin"],                       intensity: ["belirgin"],          reason: "Derin ve dikkat çekici; akşam için yoğun, iz bırakan bir kimlik." };
    CATALOG[P.FORTUNE] = { name: "Fortune", subtitle: "Vanilya · Çiçeksi · Amber",   price: 1199, image: IMGBASE + "1600x200_Fortune.jpg?v=1781278295",    time: ["aksam","gunboyu"],  notes: ["odunsu","amber"],              intensity: ["belirgin"],          reason: "Odunsu-amberimsi, yoğun ve etkileyici; güçlü bir duruş isteyenlere." };
    CATALOG[P.OCEANE]  = { name: "Océane",  subtitle: "Ferah · Deniz · Narenciye",   price: 1399, image: IMGBASE + "1600x200_Oceane.jpg?v=1781278297",     time: ["gunduz"],           notes: ["aquatic","citrus"],            intensity: ["hafif"],             reason: "Aquatic-citrus, ferah ve temiz; hafif bir gündüz tazeliği." };
    CATALOG[P.ELAN]    = { name: "Élan",    subtitle: "Aromatik · Fresh · Füjer",    price: 1399, image: IMGBASE + "illusion-u-ru-nelan.jpg?v=1779275879",   time: ["gunduz","gunboyu"], notes: ["narenciye","temiz","odunsu"],  intensity: ["dengeli"],           reason: "Narenciye ve temiz-odunsu; dengeli, çok yönlü bir ferahlık." };
    CATALOG[P.NUAGE]   = { name: "Nuage",   subtitle: "Narenciye · Marin · Fresh",   price: 1399, image: IMGBASE + "illusion-u-ru-nnuaage.jpg?v=1779275924", time: ["gunduz","gunboyu"], notes: ["miskli","yumusak","temiz"],    intensity: ["hafif","dengeli"],   reason: "Miskli, yumuşak ve temiz; rafine ve hafif bir denge." };
    CATALOG[P.ARWEN]   = { name: "Arwen",   subtitle: "Vanilya · Odunsu · Baharatlı", price: 1399, image: IMGBASE + "1600x2000_Arwen.jpg?v=1781278298",     time: ["gunboyu","aksam"],  notes: ["sicak","odunsu"],              intensity: ["dengeli","belirgin"], reason: "Sıcak-odunsu, sarıp saran; gün boyundan akşama belirgin bir karakter." };
    CATALOG[P.AUSTIN]  = { name: "Austin",  subtitle: "Odunsu · Baharatlı · Amber",  price: 1399, image: IMGBASE + "2000x2000_kapak_austin.jpg?v=1781862878", time: ["aksam"],            notes: ["odunsu","derin"],              intensity: ["belirgin"],          reason: "Odunsu-derin, yoğun ve etkileyici; akşam için güçlü bir imza." };

    var POOLS = {
      kadin: {
        ferah:  { main: [P.AERIEN, P.LUMIERE], alt: [P.IDYLLE, P.AMELINE] },
        rafine: { main: [P.IDYLLE, P.ROSELIE], alt: [P.AMELINE, P.LUMIERE] },
        sicak:  { main: [P.DORE, P.SOLENA],    alt: [P.AMBRE, P.ROSELIE] },
        yogun:  { main: [P.MIRAGE, P.FORTUNE], alt: [P.AMBRE, P.SOLENA] },
      },
      erkek: {
        ferah:  { main: [P.OCEANE, P.ELAN], alt: [P.NUAGE] },
        rafine: { main: [P.NUAGE, P.ELAN],  alt: [P.OCEANE] },
        sicak:  { main: [P.ARWEN],          alt: [P.ELAN] },
        yogun:  { main: [P.AUSTIN, P.ARWEN],alt: [P.ELAN] },
      },
    };

    var OVERRIDES = {};
    (function () {
      var rp = config.resultProducts;
      if (!rp || !rp.length) return;
      rp.forEach(function (cp) {
        if (cp && cp.handle) OVERRIDES[cp.handle] = cp;
      });
    })();

    function scoreHandle(handle, a) {
      var p = CATALOG[handle];
      if (!p) return { handle: handle, s: -1, note: false };
      var s = 0, noteHit = false;
      var want = NOTE_MAP[a.note] || [];
      for (var i = 0; i < p.notes.length; i++) {
        if (want.indexOf(p.notes[i]) > -1) { noteHit = true; break; }
      }
      if (noteHit) s += 3;
      if (a.time && p.time.indexOf(a.time) > -1) s += 2;
      if (a.intensity && p.intensity.indexOf(a.intensity) > -1) s += 2;
      return { handle: handle, s: s, note: noteHit };
    }
    function bestOf(list, a, exclude) {
      var ranked = list
        .filter(function (h) { return h !== exclude; })
        .map(function (h, idx) { var r = scoreHandle(h, a); r.idx = idx; return r; })
        .sort(function (x, y) {
          if (y.s !== x.s) return y.s - x.s;
          if (y.note !== x.note) return (y.note ? 1 : 0) - (x.note ? 1 : 0);
          return x.idx - y.idx;
        });
      return ranked.length ? ranked[0].handle : null;
    }
    function computeResult(a) {
      var cat = POOLS[a.category];
      if (!cat) return null;
      var pool = cat[a.effect];
      if (!pool) return null;
      var main = bestOf(pool.main, a, null);
      var alt = bestOf(pool.main.concat(pool.alt), a, main);
      return { main: main, alt: alt };
    }

    function resolveProduct(handle) {
      var base = CATALOG[handle] || {};
      var o = { handle: handle };
      for (var k in base) if (Object.prototype.hasOwnProperty.call(base, k)) o[k] = base[k];
      var ov = OVERRIDES[handle];
      if (ov) {
        if (ov.url) o.url = ov.url;
        if (ov.title) o.name = ov.title;
        /* Mağaza ana ürün görseli (görsel 1) — sabit kapak görsellerinin yerine */
        if (ov.featured_image) o.image = ov.featured_image;
        if (ov.price_cents != null && ov.price_cents !== "") o.price = Number(ov.price_cents) / 100;
      }
      if (!o.url) o.url = "/products/" + handle;
      return o;
    }

    var STEPS;
    if (config.stepsFromTheme && config.stepsFromTheme.length) {
      STEPS = config.stepsFromTheme
        .map(function (row) {
          var def = DEFAULT_STEPS.find(function (s) { return s.id === row.id; });
          if (!def) return null;
          var o = {};
          for (var k in def) if (Object.prototype.hasOwnProperty.call(def, k)) o[k] = def[k];
          if (row.number != null && String(row.number).trim() !== "") o.number = row.number;
          if (row.question != null && String(row.question).trim() !== "") o.question = row.question;
          if (row.hint != null && String(row.hint).trim() !== "") o.hint = row.hint;
          if (row.options && row.options.length) o.options = row.options;
          return o;
        })
        .filter(function (s) { return s != null; });
    }
    if (!STEPS || !STEPS.length) {
      STEPS = DEFAULT_STEPS.map(function (s) { var c = {}; for (var k in s) c[k] = s[k]; return c; });
    }

    var landingHtml = main.innerHTML;
    var stepIndex = 0;
    var answers = {};
    var phase = "landing";

    var topLeft = qs("[data-scent-top-left]");
    var topRight = qs("[data-scent-top-right]");
    var quizBar = qs("[data-scent-quiz-progress]");
    var quizFill = qs("[data-scent-quiz-progress-fill]");
    var bottomDots = qs("[data-scent-bottom]");

    function findStepOptionLabel(step, value) {
      if (!step || !step.options) return value;
      for (var i = 0; i < step.options.length; i++) {
        if (step.options[i].value === value) return step.options[i].label;
      }
      return value;
    }

    function formatAnswersForExport() {
      var out = {};
      STEPS.forEach(function (step) {
        var ans = answers[step.id];
        if (ans == null || ans === "") return;
        out[step.id] = ans;
        out[step.id + "_label"] = findStepOptionLabel(step, ans);
      });
      return out;
    }

    function buildSheetPayload(results) {
      return {
        completedAt: new Date().toISOString(),
        shop:
          (window.Shopify && window.Shopify.shop) ||
          (window.theme && window.theme.shop) ||
          window.location.hostname,
        pageUrl: window.location.href,
        answers: formatAnswersForExport(),
        topResults: results.map(function (p, i) {
          return { rank: i + 1, name: p.name, handle: p.handle, url: p.url };
        }),
      };
    }

    function submitScentResultsToSheets(results) {
      if (!storageCfg.sheetsEnabled) return;
      var webhookUrl = storageCfg.sheetsWebhookUrl ? String(storageCfg.sheetsWebhookUrl).trim() : "";
      if (!webhookUrl) return;
      var payload = buildSheetPayload(results);
      var signature = JSON.stringify(payload.answers);
      try {
        if (sessionStorage.getItem(SHEET_SENT_KEY) === signature) return;
        sessionStorage.setItem(SHEET_SENT_KEY, signature);
      } catch (e) {}
      fetch(webhookUrl, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () {});
    }

    function setQuizProgressFrac(frac) {
      if (quizFill) quizFill.style.width = Math.min(100, Math.max(0, frac * 100)) + "%";
    }
    function showQuizBar() { if (quizBar) quizBar.classList.remove("hidden"); }
    function hideQuizBar() {
      if (quizBar) quizBar.classList.add("hidden");
      if (quizFill) quizFill.style.width = "0%";
    }

    function renderTopDots() {
      if (!topLeft) return;
      if (phase === "quiz") {
        topLeft.innerHTML = STEPS.map(function (_, i) {
          return (
            '<div class="rounded-full transition-all duration-500" style="width:' +
            (i === stepIndex ? "20px" : "5px") + ";height:5px;background:" +
            (i <= stepIndex ? "rgba(255,255,255,0.8)" : "rgba(255,255,255,0.18)") + '"></div>'
          );
        }).join("");
      } else if (phase === "results") {
        topLeft.innerHTML =
          '<button type="button" data-scent-reset="" class="flex items-center gap-1.5 text-white/35 hover:text-white/70 transition-colors" style="font-size:11px;letter-spacing:0.1em"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>Yeniden</button>';
      } else {
        topLeft.innerHTML = '<div class="w-5 h-px"></div>';
      }
    }

    function renderTopRight() {
      if (!topRight) return;
      if (phase === "quiz") {
        topRight.innerHTML =
          '<button type="button" data-scent-back="" class="text-white/35 hover:text-white/70 transition-colors" style="font-size:11px;letter-spacing:0.1em"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg></button>';
      } else if (phase === "landing") {
        if (ui.showTopClose === false) topRight.innerHTML = "";
        else topRight.innerHTML =
          '<a href="' + esc(closeHref) + '" class="text-white/35 hover:text-white/70 transition-colors" style="font-size:11px;letter-spacing:0.1em">✕</a>';
      } else {
        topRight.innerHTML = "";
      }
    }

    function renderBottomDots() {
      if (!bottomDots) return;
      if (phase !== "quiz") { bottomDots.classList.add("hidden"); return; }
      bottomDots.classList.remove("hidden");
      bottomDots.innerHTML =
        '<div class="flex items-center gap-2">' +
        STEPS.map(function (_, i) {
          return (
            '<div class="rounded-full transition-all duration-300" style="width:' +
            (i === stepIndex ? "16px" : "4px") + ";height:4px;background:" +
            (i < stepIndex ? "rgba(255,255,255,0.45)" : i === stepIndex ? "rgba(255,255,255,0.75)" : "rgba(255,255,255,0.12)") +
            '"></div>'
          );
        }).join("") + "</div>";
    }

    function isSelected(step, value) {
      var ans = answers[step.id];
      if (!ans) return false;
      return Array.isArray(ans) ? ans.indexOf(value) !== -1 : ans === value;
    }
    function canProceed(step) {
      var ans = answers[step.id];
      if (!ans) return false;
      return Array.isArray(ans) ? ans.length > 0 : true;
    }

    function renderQuiz() {
      var step = STEPS[stepIndex];
      if (!step || !step.options || !step.options.length) return;
      var gridCols = step.options.length <= 3 ? "grid-cols-1 sm:grid-cols-3" : "grid-cols-2";
      var opts = step.options.map(function (opt, i) {
        var sel = isSelected(step, opt.value);
        return (
          '<button type="button" data-scent-opt="' + esc(opt.value) +
          '" class="group relative rounded-xl px-5 py-4 text-left transition-all duration-200 ' +
          (sel ? "bg-white" : "bg-transparent border border-white/12 hover:border-white/35") +
          '" style="animation:sfOpt .35s cubic-bezier(.22,1,.36,1) ' + i * 0.04 + 's both">' +
          '<p style="font-size:14px;font-weight:' + (sel ? "500" : "400") + ";color:" +
          (sel ? "#0A0A0A" : "rgba(255,255,255,0.85)") + ';letter-spacing:0.01em;line-height:1.2">' +
          esc(opt.label) + "</p>" +
          '<p style="font-size:11px;font-weight:300;color:' +
          (sel ? "rgba(0,0,0,0.45)" : "rgba(255,255,255,0.28)") + ';margin-top:4px">' +
          esc(opt.sub) + "</p></button>"
        );
      }).join("");
      main.innerHTML =
        '<div class="w-full max-w-[680px] py-20 sf-quiz-enter">' +
        '<div class="mb-10">' +
        '<p class="text-white/20 mb-4" style="font-size:11px;letter-spacing:0.2em">' +
        esc(step.number) + " — " + esc(step.hint) + "</p>" +
        '<h2 style="font-family:Inter,sans-serif;font-size:clamp(28px,4.5vw,50px);font-weight:300;line-height:1.1;color:white">' +
        esc(step.question) + "</h2></div>" +
        '<div class="grid gap-2 mb-12 ' + gridCols + '">' + opts + "</div>" +
        '<div class="flex items-center justify-between">' +
        '<span class="text-white/20" style="font-size:11px;letter-spacing:0.15em">' +
        (stepIndex + 1) + " / " + STEPS.length + "</span>" +
        '<button type="button" data-scent-next="" class="inline-flex items-center gap-2.5 pb-0.5 transition-all ' +
        (canProceed(step)
          ? "text-white border-b border-white/30 hover:border-white/70 cursor-pointer hover:translate-x-[3px]"
          : "text-white/18 cursor-not-allowed border-b border-transparent") +
        '" style="font-size:12px;letter-spacing:0.12em">' +
        (stepIndex === STEPS.length - 1 ? L.quizFinish : L.quizContinue) +
        '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></button></div></div>';
    }

    function priceStr(v) {
      if (v == null || isNaN(v)) return "";
      return "₺" + Number(v).toLocaleString("tr-TR", { minimumFractionDigits: 2 });
    }

    function pickCard(p, kind) {
      var isMain = kind === "main";
      var label = isMain ? "Ana Öneri" : L.resultsAsideLabel;
      var cta = isMain ? L.reviewMain : L.reviewAlt;
      var imgSize = isMain ? "150px" : "110px";
      var nameSize = isMain ? "34px" : "24px";
      var nameColor = isMain ? "white" : "rgba(255,255,255,0.62)";
      var border = isMain ? "rgba(255,255,255,0.18)" : "rgba(255,255,255,0.08)";
      var btnCls = isMain
        ? "border-white/40 text-white hover:bg-white hover:text-black"
        : "border-white/15 text-white/55 hover:border-white/40 hover:text-white/85";
      var delay = isMain ? 0.25 : 0.4;
      return (
        '<div class="flex items-center gap-6 md:gap-9" style="padding:28px 0;border-top:1px solid ' + border +
        ';animation:sfRow .55s cubic-bezier(.22,1,.36,1) ' + delay + 's both;opacity:0">' +
        '<div class="flex-shrink-0" style="width:' + imgSize + '">' +
        '<img src="' + esc(p.image) + '" alt="' + esc(p.name) +
        '" style="width:100%;height:auto;object-fit:contain;opacity:' + (isMain ? "1" : "0.78") +
        ';filter:drop-shadow(0 6px 18px rgba(0,0,0,0.55))"/></div>' +
        '<div class="flex-1 min-w-0">' +
        '<p class="uppercase" style="font-size:9px;letter-spacing:0.28em;color:' +
        (isMain ? "rgba(255,255,255,0.55)" : "rgba(255,255,255,0.3)") + ';margin-bottom:8px">' +
        esc(label) + "</p>" +
        '<h3 style="font-family:Inter,sans-serif;font-size:' + nameSize +
        ';font-weight:400;line-height:1;color:' + nameColor + ';margin-bottom:6px">' + esc(p.name) + "</h3>" +
        (p.subtitle
          ? '<p class="uppercase" style="font-size:9px;letter-spacing:0.18em;color:rgba(255,255,255,0.3);margin-bottom:10px">' + esc(p.subtitle) + "</p>"
          : "") +
        '<p style="font-size:13.5px;font-weight:300;line-height:1.55;color:rgba(255,255,255,0.5);max-width:46ch;margin-bottom:16px">' +
        esc(p.reason) + "</p>" +
        '<div class="flex items-center gap-5">' +
        '<a href="' + esc(p.url) +
        '" class="inline-flex items-center gap-2 rounded-full px-5 py-2.5 border transition-all ' + btnCls +
        '" style="font-size:11px;letter-spacing:0.08em">' + esc(cta) +
        '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>' +
        (p.price ? '<span style="font-size:13px;font-weight:300;color:rgba(255,255,255,0.4)">' + priceStr(p.price) + "</span>" : "") +
        "</div></div></div>"
      );
    }

    function renderResults(mainP, altP) {
      var cards = pickCard(mainP, "main") + (altP ? pickCard(altP, "alt") : "");
      main.innerHTML =
        '<div class="w-full max-w-[720px] py-24 sf-results-enter">' +
        '<div class="mb-12" style="animation:sfHdr .6s ease both;opacity:0">' +
        '<p class="text-white/25 uppercase mb-4" style="font-size:10px;letter-spacing:0.3em">' +
        esc(L.resultsKicker) + "</p>" +
        '<h2 style="font-family:Inter,sans-serif;font-size:clamp(40px,7vw,78px);font-weight:300;line-height:0.95;color:white">' +
        L.resultsTitleHtml + "</h2></div>" +
        '<div>' + cards + "</div>" +
        '<div class="flex items-center gap-8 mt-12" style="animation:sfFade .6s ease 0.9s both;opacity:0">' +
        '<button type="button" data-scent-reset2="" class="inline-flex items-center gap-2 text-white/30 hover:text-white/60 transition-colors" style="font-size:11px;letter-spacing:0.12em"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>' +
        esc(L.repeatQuiz) + "</button>" +
        '<a href="' + esc(rootUrl) + '" class="text-white/30 hover:text-white/60 transition-colors" style="font-size:11px;letter-spacing:0.12em">' +
        esc(L.homeLink) + "</a></div></div>";
    }

    function goLanding() {
      phase = "landing";
      stepIndex = 0;
      answers = {};
      try { sessionStorage.removeItem(SHEET_SENT_KEY); } catch (e) {}
      main.innerHTML = landingHtml;
      hideQuizBar();
      renderTopDots();
      renderTopRight();
      if (bottomDots) bottomDots.classList.add("hidden");
    }

    function goQuiz() {
      if (!STEPS.length) return;
      phase = "quiz";
      showQuizBar();
      setQuizProgressFrac((stepIndex + 1) / STEPS.length);
      renderTopDots();
      renderTopRight();
      renderQuiz();
      renderBottomDots();
    }

    function goResults() {
      phase = "results";
      hideQuizBar();
      renderTopDots();
      renderTopRight();
      if (bottomDots) bottomDots.classList.add("hidden");
      var r = computeResult(answers);
      if (!r || !r.main) { goLanding(); return; }
      var mainP = resolveProduct(r.main);
      var altP = r.alt ? resolveProduct(r.alt) : null;
      var list = altP ? [mainP, altP] : [mainP];
      submitScentResultsToSheets(list);
      renderResults(mainP, altP);
    }

    function goNext() {
      var step = STEPS[stepIndex];
      if (!canProceed(step)) return;
      if (stepIndex < STEPS.length - 1) {
        stepIndex++;
        setQuizProgressFrac((stepIndex + 1) / STEPS.length);
        renderQuiz();
        renderTopDots();
        renderBottomDots();
      } else {
        goResults();
      }
    }

    function bindMainClicks(e) {
      var t = e.target;
      if (!main.contains(t)) return;
      var step = STEPS[stepIndex];
      var next = t.closest("[data-scent-next]");
      var optB = t.closest("[data-scent-opt]");
      if (optB && step) {
        var val = optB.getAttribute("data-scent-opt");
        if (step.type === "multi") {
          var cur = answers[step.id] || [];
          var ix = cur.indexOf(val);
          if (ix === -1) cur = cur.concat([val]);
          else cur = cur.filter(function (x) { return x !== val; });
          answers[step.id] = cur;
          renderQuiz();
          renderBottomDots();
          setQuizProgressFrac((stepIndex + 1) / STEPS.length);
        } else {
          answers[step.id] = val;
          renderQuiz();
          renderBottomDots();
          setQuizProgressFrac((stepIndex + 1) / STEPS.length);
          var advStep = step;
          var advVal = val;
          setTimeout(function () {
            if (phase === "quiz" && STEPS[stepIndex] === advStep && answers[advStep.id] === advVal) {
              goNext();
            }
          }, 260);
        }
        return;
      }
      if (next) {
        goNext();
      }
    }

    document.addEventListener("click", function (e) {
      if (!page.contains(e.target)) return;
      if (e.target.closest('a[href*="/products/"]')) return;
      if (e.target.closest("[data-scent-start]")) { e.preventDefault(); goQuiz(); return; }
      var back = e.target.closest("[data-scent-back]");
      if (back) {
        e.preventDefault();
        if (stepIndex === 0) goLanding();
        else {
          stepIndex--;
          setQuizProgressFrac((stepIndex + 1) / STEPS.length);
          renderQuiz();
          renderTopDots();
          renderBottomDots();
        }
        return;
      }
      var rst = e.target.closest("[data-scent-reset]") || e.target.closest("[data-scent-reset2]");
      if (rst) { e.preventDefault(); goLanding(); return; }
      bindMainClicks(e);
    });

    if (!document.getElementById("sf-anim-style")) {
      var st = document.createElement("style");
      st.id = "sf-anim-style";
      st.textContent =
        "@keyframes sfFade{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}" +
        "@keyframes sfOpt{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}" +
        "@keyframes sfRow{from{opacity:0;transform:translateX(-16px)}to{opacity:1;transform:translateX(0)}}" +
        "@keyframes sfHdr{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}" +
        ".sf-quiz-enter{animation:sfFade .45s cubic-bezier(.22,1,.36,1) both}" +
        ".sf-results-enter{opacity:1}" +
        "[data-scent-start]{transition:transform .2s ease}" +
        "[data-scent-start]:hover{transform:translateX(4px)}";
      document.head.appendChild(st);
    }
  }
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initScentFinder);
else initScentFinder();
})();
